export default {
  nav: {
    services: 'Services',
    process: 'Process',
    whyUs: 'Why Us',
    portfolio: 'Portfolio',
    about: 'About',
    contact: 'Contact',
    getInTouch: 'Get in Touch',
    goHome: 'Go to home',
    language: 'Language',
    menu: 'Menu',
  },
  hero: {
    tagline: 'End-to-End Software Engineering',
    subtitle: 'A software studio in Montevideo, Uruguay. We build mobile apps and the platforms behind them, from first version to production. Since 2023.',
    ourServices: 'Our Services',
  },
  trustedBy: {
    title: 'Trusted By',
  },
  services: {
    eyebrow: 'Core Solutions',
    title: 'What We Build',
    subtitle: 'Comprehensive software solutions tailored to your business needs',
    items: {
      web: {
        title: 'Custom Web Applications',
        description:
          'Modern, scalable platforms built with React, Next.js, TypeScript, Node.js and NestJS.',
        tags: ['React', 'Next.js', 'TypeScript', 'Node.js'],
      },
      mobile: {
        title: 'Mobile Applications',
        description: 'High-performance cross-platform apps using React Native.',
        tags: ['React Native', 'iOS', 'Android', 'Cross-platform'],
      },
      integrations: {
        title: 'API & System Integrations',
        description:
          'Secure integrations with payment systems, CRM, logistics, ticketing and AI-powered services.',
        tags: ['Payment Systems', 'CRM', 'Logistics', 'AI Services'],
      },
    },
  },
  whyUs: {
    title: 'Why Work With Ventura Software',
    items: {
      bilingual: {
        title: 'We work in English and Spanish',
        description:
          'Meetings, documentation and day-to-day communication in whichever of the two your team prefers. Spanish is our native language.',
      },
      meet: {
        title: 'Meet Your Developer',
        description:
          'Clients can meet and interview the assigned engineer to confirm technical and cultural alignment.',
      },
      support: {
        title: 'Reliable Support',
        description:
          'We provide consistent engineering capacity with optional PM and QA when needed.',
      },
      rotation: {
        title: 'Low Rotation',
        description:
          'Stable long-term team that reduces onboarding overhead and ensures continuity.',
      },
    },
  },
  process: {
    eyebrow: 'Our Process',
    title: 'End-to-End Development',
    subtitle: 'How a project goes from the first call to production.',
    step: 'Step {{number}}',
    steps: {
      discovery: {
        title: 'Discovery',
        description:
          'Requirements gathering, market research, and strategic planning to align on goals.',
      },
      design: {
        title: 'UI/UX Design',
        description:
          'Wireframes, interactive prototypes, and comprehensive design systems.',
      },
      development: {
        title: 'Development',
        description:
          'Agile sprints with code reviews, automated testing, and continuous integration.',
      },
      qa: {
        title: 'QA & Testing',
        description:
          'Comprehensive testing including automated tests, manual QA, and performance optimization.',
      },
      launch: {
        title: 'Launch',
        description:
          'Deployment to production, monitoring setup, and performance optimization.',
      },
      support: {
        title: 'Support & Growth',
        description:
          'Ongoing maintenance, feature updates, and scaling as your business grows.',
      },
    },
  },
  about: {
    eyebrow: 'About Ventura Software',
    titleLine1: 'Engineering Excellence',
    titleLine2: 'from Uruguay',
    body:
      'Ventura Software is a boutique engineering studio focused on delivering reliable, scalable and high-quality digital products. We help companies expand and strengthen their product capabilities through senior engineering expertise.',
  },
  contact: {
    title: 'Tell us what you need. We reply within 24 hours.',
    body: 'Book a 30-minute call, email us or send a WhatsApp message. Or use the form.',
    email: 'Email',
    phone: 'Phone',
    location: 'Location',
    bookCall: 'Book a 30-min call',
    privacyNotice: 'We use your data only to reply to you. The form is delivered via EmailJS.',
    privacyLink: 'Privacy policy',
    form: {
      name: 'Name',
      namePlaceholder: 'John Doe',
      email: 'Email',
      emailPlaceholder: 'john@company.com',
      message: 'Message',
      messagePlaceholder: 'Tell us about your project...',
      maxChars: 'Maximum 500 characters',
      submit: 'Start a Conversation',
      sending: 'Sending...',
      success:
        "Thank you! Your message has been sent successfully. We'll get back to you soon.",
      error: 'Oops! Something went wrong. Please try again later.',
    },
  },
  footer: {
    tagline: 'Building exceptional digital products with senior engineering teams.',
    quickLinks: 'Quick Links',
    getInTouch: 'Get in Touch',
    rights: '© {{year}} Ventura Software. All rights reserved.',
  },
  notFound: {
    title: 'This page does not exist',
    body: 'The page you are looking for may have been moved or removed.',
    backHome: 'Back to home',
  },
};
